import { CellProps } from 'react-table'
import { LogAcessoView } from '../../core/_models'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { TFunction } from '_metronic/i18n/Metronici18n'
import { formatDateTime } from '_metronic/helpers'
import { sortableColumn, StackedCell, StatusDot, StatusDotTone, TableColumn } from 'app/components'

/** Tom do status HTTP: 2xx sucesso, 3xx informativo, 4xx atenção, 5xx erro. */
const statusTone = (status?: number): StatusDotTone => {
  if (!status) return 'neutral'
  if (status >= 500) return 'danger'
  if (status >= 400) return 'warning'
  if (status >= 300) return 'info'
  return 'success'
}

export const LogsUsuarioIdColumns = (t: TFunction): ReadonlyArray<TableColumn<LogAcessoView>> => [
  sortableColumn<LogAcessoView>({
    id: 'data',
    cellWidth: '170px',
    useQueryRequest,
    fields: [{ field: 'data', label: t('cols.data') }],
    Cell: ({ row }: CellProps<LogAcessoView>) => (
      <StackedCell
        tabular
        primary={formatDateTime(row.original.data, row.original.dataFormatada)}
      />
    ),
  }),
  sortableColumn<LogAcessoView>({
    id: 'descricao',
    useQueryRequest,
    fields: [{ field: 'descricao', label: 'Descrição' }],
    Cell: ({ row }: CellProps<LogAcessoView>) => <StackedCell primary={row.original.descricao} />,
  }),
  // URL com o método HTTP como apoio; os dois seguem ordenáveis.
  sortableColumn<LogAcessoView>({
    id: 'url',
    hideOnMobile: true,
    useQueryRequest,
    fields: [
      { field: 'url', label: 'URL' },
      { field: 'metodo', label: 'Método' },
    ],
    Cell: ({ row }: CellProps<LogAcessoView>) => (
      <StackedCell primary={row.original.url} secondary={row.original.metodo} />
    ),
  }),
  // Código em texto + tom: a cor só reforça.
  sortableColumn<LogAcessoView>({
    id: 'status',
    cellWidth: '110px',
    useQueryRequest,
    fields: [{ field: 'status', label: t('cols.status') }],
    Cell: ({ row }: CellProps<LogAcessoView>) =>
      row.original.status ? (
        <StatusDot label={String(row.original.status)} tone={statusTone(row.original.status)} />
      ) : (
        <StackedCell primary={undefined} />
      ),
  }),
]
